import React from "react";

const SideBar = () => {
  return (
    <>
      <div className="tour_details_right_sidebar_wrapper">
        <div className="tour_detail_right_sidebar">
          <div className="tour_details_right_boxed">
            <div className="tour_details_right_box_heading">
              <h3>Package Info</h3>
            </div>
            <div className="valid_date_area">
              <div className="valid_date_area_one">
                <h5>Valid from</h5>
                <p>31 May 2025</p>
              </div>
              <div className="valid_date_area_one">
                <h5>Valid till</h5>
                <p>12 June 2025</p>
              </div>
            </div>
            <div className="tour_package_details_bar_list">
              <h5>Package details</h5>
              <ul>
                <li>
                  <i className="fas fa-circle"></i>
                  Return Air Ticket from Karachi
                </li>
                <li>
                  <i className="fas fa-circle"></i>
                  Makkah Hotel Near to Haram
                </li>
                <li>
                  <i className="fas fa-circle"></i>
                  VIP Luxury Buses
                </li>
                <li>
                  <i className="fas fa-circle"></i>
                  24 Hours Hot and Cold Berera
                </li>
                <li>
                  <i className="fas fa-circle"></i>
                  Ziarat in Makkah & Madina
                </li>
                <li>
                  <i className="fas fa-circle"></i>
                  Hajj Kits with Gift Bags
                </li>
                <li>
                  <i className="fas fa-circle"></i>
                  24/7 Meet & Greet Assistance
                </li>
                <li>
                  <i className="fas fa-circle"></i>
                  Maktab A Closest To Jamarat
                </li>
              </ul>
            </div>
            {/* <div className="tour_package_details_bar_price">
              <h5>Price</h5>
              <div className="tour_package_bar_price">
                <h6>
                  <del>$ 35,500</del>
                </h6>
                <h3>
                  $ 30,500 <sub>/Per serson</sub>{" "}
                </h3>
              </div>
            </div> */}
          </div>
          {/* <div className="tour_select_offer_bar_bottom">
            <button
              className="btn btn_theme btn_md w-100"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
            >
              Select offer
            </button>
          </div> */}
        </div>
        <div className="tour_detail_right_sidebar">
          <div className="tour_details_right_boxed">
            <div className="tour_details_right_box_heading">
              <h3>Double</h3>
            </div>
            {/* <div className="valid_date_area">
              <div className="valid_date_area_one">
                <h5>Valid from</h5>
                <p>01 Feb 2022</p>
              </div>
              <div className="valid_date_area_one">
                <h5>Valid till</h5>
                <p>15 Feb 2022</p>
              </div>
            </div> */}
            <div className="tour_package_details_bar_list">
              <h5>Package details</h5>
              <ul>
                <li>
                  <i className="fas fa-circle"></i>Buffet breakfast as per the
                  Itinerary
                </li>
                <li>
                  <i className="fas fa-circle"></i>Visit eight villages
                  showcasing Polynesian culture
                </li>
                <li>
                  <i className="fas fa-circle"></i>Complimentary Camel safari,
                  Bonfire,
                </li>
              </ul>
            </div>
            <div className="tour_package_details_bar_price">
              <h5>Price</h5>
              <div className="tour_package_bar_price">
                {/* <h6>
                  <del>$ 13,270</del>
                </h6> */}
                <h3>
                  PKR 3,795,000 <sub>/Per serson</sub>{" "}
                </h3>
                <h3>
                  $ 13,270 <sub>/Per serson</sub>{" "}
                </h3>
                <h3>
                  SR 49,940 <sub>/Per serson</sub>{" "}
                </h3>
              </div>
            </div>
          </div>
          <div className="tour_select_offer_bar_bottom">
            <button
              className="btn btn_theme btn_md w-100"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
            >
              Select offer
            </button>
          </div>
        </div>

        <div className="tour_detail_right_sidebar">
          <div className="tour_details_right_boxed">
            <div className="tour_details_right_box_heading">
              <h3>Tripple</h3>
            </div>
            {/* <div className="valid_date_area">
              <div className="valid_date_area_one">
                <h5>Valid from</h5>
                <p>01 Feb 2022</p>
              </div>
              <div className="valid_date_area_one">
                <h5>Valid till</h5>
                <p>15 Feb 2022</p>
              </div>
            </div> */}
            <div className="tour_package_details_bar_list">
              <h5>Package details</h5>
              <ul>
                <li>
                  <i className="fas fa-circle"></i>Buffet breakfast as per the
                  Itinerary
                </li>
                <li>
                  <i className="fas fa-circle"></i>Visit eight villages
                  showcasing Polynesian culture
                </li>
                <li>
                  <i className="fas fa-circle"></i>Complimentary Camel safari,
                  Bonfire,
                </li>
              </ul>
            </div>
            <div className="tour_package_details_bar_price">
              <h5>Price</h5>
              <div className="tour_package_bar_price">
                {/* <h6>
                  <del>$ 13,270</del>
                </h6> */}
                <h3>
                  PKR 3,795,000 <sub>/Per serson</sub>{" "}
                </h3>
                <h3>
                  $ 13,270 <sub>/Per serson</sub>{" "}
                </h3>
                <h3>
                  SR 49,940 <sub>/Per serson</sub>{" "}
                </h3>
              </div>
            </div>
          </div>
          <div className="tour_select_offer_bar_bottom">
            <button
              className="btn btn_theme btn_md w-100"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
            >
              Select offer
            </button>
          </div>
        </div>
        <div className="tour_detail_right_sidebar">
          <div className="tour_details_right_boxed">
            <div className="tour_details_right_box_heading">
              <h3>Quad</h3>
            </div>
            {/* <div className="valid_date_area">
              <div className="valid_date_area_one">
                <h5>Valid from</h5>
                <p>01 Feb 2022</p>
              </div>
              <div className="valid_date_area_one">
                <h5>Valid till</h5>
                <p>15 Feb 2022</p>
              </div>
            </div> */}
            <div className="tour_package_details_bar_list">
              <h5>Package details</h5>
              <ul>
                <li>
                  <i className="fas fa-circle"></i>Buffet breakfast as per the
                  Itinerary
                </li>
                <li>
                  <i className="fas fa-circle"></i>Visit eight villages
                  showcasing Polynesian culture
                </li>
                <li>
                  <i className="fas fa-circle"></i>Complimentary Camel safari,
                  Bonfire,
                </li>
              </ul>
            </div>
            <div className="tour_package_details_bar_price">
              <h5>Price</h5>
              <div className="tour_package_bar_price">
                {/* <h6>
                  <del>$ 13,270</del>
                </h6> */}
                <h3>
                  PKR 3,795,000 <sub>/Per serson</sub>{" "}
                </h3>
                <h3>
                  $ 13,270 <sub>/Per serson</sub>{" "}
                </h3>
                <h3>
                  SR 49,940 <sub>/Per serson</sub>{" "}
                </h3>
              </div>
            </div>
          </div>
          <div className="tour_select_offer_bar_bottom">
            <button
              className="btn btn_theme btn_md w-100"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
            >
              Select offer
            </button>
          </div>
        </div>
        <div className="tour_detail_right_sidebar">
          <div className="tour_details_right_boxed">
            <div className="tour_details_right_box_heading">
              <h3>Why choose us</h3>
            </div>

            <div className="tour_package_details_bar_list first_child_padding_none">
              <ul>
                <li>
                  <i className="fas fa-circle"></i>Buffet breakfast as per the
                  Itinerary
                </li>
                <li>
                  <i className="fas fa-circle"></i>Visit eight villages
                  showcasing Polynesian culture
                </li>
                <li>
                  <i className="fas fa-circle"></i>Complimentary Camel safari,
                  Bonfire,
                </li>
                <li>
                  <i className="fas fa-circle"></i>All toll tax, parking, fuel,
                  and driver allowances
                </li>
                <li>
                  <i className="fas fa-circle"></i>Comfortable and hygienic
                  vehicle
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
